import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetSkill(skillId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/skill/" + skillId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetSkills(includeDisabled) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/skill/",
        params: includeDisabled ? { includeDisabled: true } : undefined,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetSkillUsage() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/skill/usage",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetSkillRates(client, account) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/skill/rates",
        params: account ? { client, account } : { client },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSaveSkillRates(client, account, rates) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/skill/rates",
        data: { client, account: account || undefined, rates },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestEditSkill(skillId, skillData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/skill/" + skillId,
        data: skillData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateSkill(skillData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/skill/",
        data: skillData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteSkill(skillId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/skill/" + skillId,
        withCredentials: true,
        crossorigin: true
    });
}
